import backend from "../../api/api";
import { store } from "../../redux/store";


const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

// Get all online orders
export const getAllOnlineOrders = (params = {}) => async (dispatch) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();

    // Add pagination params
    if (params.page) queryParams.append('page', params.page);
    if (params.page_size) queryParams.append('page_size', params.page_size);

    // Add filter params
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    // if (params.phone) queryParams.append('phone', params.phone);
    if (params.search) queryParams.append('search', params.search);


    // Order status filter (Processing, Waiting, etc.)
    if (params.order_status) queryParams.append('order_status', params.order_status);

    // Ecommerce status filter (Ecommerce Pending, Confirm, Rejected)
    if (params.ecommerce_status) queryParams.append('ecommerce_status', params.ecommerce_status);

    if (params.confirm !== undefined && params.confirm !== null) {
      queryParams.append('confirm', params.confirm);
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `api/ecommerce/allonlineorder/?${queryString}`
      : "api/ecommerce/allonlineorder/";

    const response = await backend.get(url, getConfig());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Get specific online order
export const getSpecificOnlineOrder = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/ecommerce/allonlineorder/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update online order
export const updateOnlineOrder = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/ecommerce/allonlineorder/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateOnlineOrderItems = (id, items) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/update-items/`,
      { items },
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};


// Confirm online order
export const confirmOnlineOrder = (id, invoice_by) => async (dispatch) => {
  try {
    const payload = { is_printable: true };
    if (invoice_by) {
      payload.invoice_by = invoice_by;
    }
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/confirm/`,
      payload,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const rejectOnlineOrder = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/reject/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const revertOnlineOrder = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/revert/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete online order
export const deleteOnlineOrder = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/ecommerce/allonlineorder/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update online order status
export const updateOnlineOrderStatus = (id, statusData) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/ecommerce/allonlineorder/${id}/`,
      statusData,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// order_status counts
export const getOrderStatusCounts = () => async (dispatch) => {
  try {
    const response = await backend.get(
      "api/ecommerce/allonlineorder/status-counts/",
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const sendBkashSms = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/send-bkash-sms/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const sendStockOutSms = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/send-stock-out-sms/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const sendAlreadyCalledSms = (id) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/allonlineorder/${id}/send-already-called-sms/`,
      {},
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNewOrderCount = () => async (dispatch) => {
  try {
    const response = await backend.get(
      "api/ecommerce/allonlineorder/new-order-count/",
      getConfig()
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getLocationProducts = (params = {}) => async (dispatch) => {
  try {
    const query = new URLSearchParams(params).toString();
    const url = query
      ? `api/ecommerce/allonlineorder/location-products/?${query}`
      : "api/ecommerce/allonlineorder/location-products/";
    const response = await backend.get(url, getConfig());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

